 import React, {useEffect, useState} from "react";
import { getGotoUnreadCount } from "../../store/crm/goto-sms";
import { gotoSmsApi } from "../../store/crm/goto-sms/gotoSmsApi";
import {Box, Collapse, Drawer, ListItemIcon, Typography, useMediaQuery, useTheme} from "@mui/material";
import zoey from "../../assets/images/zoey.png";
import { Link } from "react-router-dom";
import {ReactComponent as Analytics} from "../../assets/icon/analytics.svg";
import {ReactComponent as  Calendar} from "../../assets/icon/calendar-outline.svg";
import {ReactComponent as CalendarNumber} from "../../assets/icon/calendar-number-outline.svg";
import {ReactComponent as Mail} from "../../assets/icon/mail-outline.svg";
import {ReactComponent as PersonAdd} from "../../assets/icon/person-add-outline.svg";
import {ReactComponent as Call} from "../../assets/icon/call-outline.svg";
import {ReactComponent as HalfStar} from "../../assets/icon/star-half.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import RequestPageIcon from '@mui/icons-material/RequestPage';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NaturePeopleIcon from '@mui/icons-material/Forest';
import InventoryIcon from '@mui/icons-material/Inventory2Outlined';
import { removeUser } from "../../store/auth";
import { hasMenuAccess  } from "../../services/utills";
import {scrollCSS} from "../../App";
import OndemandVideoIcon from '@mui/icons-material/OndemandVideoOutlined';
import {closedMixin, openedMixin} from "./adminSidebar";
import PostAddIcon from '@mui/icons-material/PostAddOutlined';
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import {styled} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInboxOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import SummarizeIcon from '@mui/icons-material/SummarizeOutlined';
import PersonIcon from '@mui/icons-material/PersonOutline';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import CategoryIcon from '@mui/icons-material/CategoryOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
 import {useDispatch, useSelector} from "react-redux";
 import {MdExpandLess, MdExpandMore} from "react-icons/md";


const listItemHoverStyle = {
    borderRadius: "8px",
    mb: "8px",
    padding: '10px 20px',
    width: '100%',
    justifyContent: 'flex-start',
    transition: 'background-color 0.3s, color 0.3s',
    position: 'relative',
    overflow: 'hidden',
    "&:hover": {
      backgroundColor: "#FAEFF5",
      color: "#1a1a2e",
      width: '100%',
      "& .MuiTypography-root": { color: '#1a1a2e' },
      "& .MuiListItemIcon-root svg, & .MuiListItemIcon-root .MuiSvgIcon-root": { color: '#A72C68' },
    },
    "&:hover::before": {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '6px',
      bottom: '6px',
      width: '4px',
      borderRadius: '0 4px 4px 0',
      background: '#A72C68',
    },
  };
const providerId = 2;
const getSideData = (user) => {
    ////console.log("SideBar User:"+user)

    // Define all menu items with a condition for the "STAFF SCHEDULE" item
    const allItems = [
        {
            name: "ZOEY AI",
            key: "Zoey-Ai",
            logo: <AdsClickIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: `/crm/Zoey-Ai`,
            active: ["Zoey-Ai"]
        },
        {
            name: "DASHBOARD",
            key: "dashboard",
            logo: <Box sx={{color:'#9CA3AF', display:'flex', '& svg':{width:28, height:28, color:'inherit', fill:'currentColor', stroke:'currentColor'}, '& svg path, & svg circle, & svg line, & svg rect, & svg polyline':{stroke:'currentColor'}}}><Analytics /></Box>,
            url: "/crm/dashboard",
            active: ['dashboard'],
        },
        {
            name: "CALENDAR",
            key: "calendar",
            logo: <CalendarMonthOutlinedIcon sx={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/calender",
            active: ['calender']
        },
        {
            name: "CRM",
            key: "crm",
            logo: <Box sx={{color:'#9CA3AF', display:'flex', '& svg':{width:28, height:28, color:'inherit', fill:'currentColor', stroke:'currentColor'}, '& svg path, & svg circle, & svg line, & svg rect, & svg polyline':{stroke:'currentColor'}}}><PersonAdd /></Box>,
            url: "/crm/customer-relationship-management",
            active: ['customer-relationship-management',]
        },
        {
            name: "CHURN & RECOVERY",
            key: "churn-recovery",
            logo: <QueryStatsOutlinedIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/churn-recovery",
            active: ['churn-recovery'],
        },
        {
            name: "CONVERSATIONS",
            key: "conversations",
            logo: <ForumOutlinedIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/conversations",
            active: ['conversations'],
        },
        {
            name: "REQUESTS",
            key: "requests",
            logo: <AssignmentTurnedInIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,
            url: "/crm/requests",
            active: ['requests'],
            count: user?.requests > 0 ? user.requests : null,  // <-- add count here
        },
        {
            name: "APPOINTMENTS",
            key: "appointment",
            logo: <EventNoteOutlinedIcon sx={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/appointments",
            active: ['appointments', 'add-appointment']
        },
  //        ...(user?.service_type === "Request"
  // ? [{
  //     name: "REQUESTS",
  //     key: "requests",
  //     logo: <AssignmentTurnedInIcon style={{ color: '#9CA3AF', fontSize: "28px" }} />,
  //     url: "/crm/requests",
  //     active: ['requests'],
  //     count: user?.requests > 0 ? user.requests : null,  // <-- add count here
  //   }]
  // : []),
        {   
            name: "POS",
            key: "pos",                
            logo: <PostAddIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/point-of-sale/new-invoice",
            active: ['new-invoice', 'point-of-sale']    
        }, 
        // INBOX (in-app chat) merged into CONVERSATIONS — /crm/chat route
        // still works for direct links.
        // Include the "STAFF SCHEDULE" conditionally 
        {
            name: "STAFF SCHEDULE",
            key: "staff-schedule",
            logo: <Box sx={{color:'#9CA3AF', display:'flex', '& svg':{width:28, height:28, color:'inherit', fill:'currentColor', stroke:'currentColor'}, '& svg path, & svg circle, & svg line, & svg rect, & svg polyline':{stroke:'currentColor'}}}><HalfStar /></Box>,
            url: user?.role_id === 4 ? `/crm/configuration/clinic/${user?.provider_id}/staff` : `/crm/configuration/clinic/${user?.id}/scheduler`,
            active: ["scheduler"]
        },
        // /crm/requestbooking
        // Include the "MEMBERSHIP" conditionally
        ...(user?.is_new === 1 ? [{
            name: "MEMBERSHIP",
            key: "membership",
            logo: <PersonIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: `/crm/membership`,
            active: ["membership"]
        }] : []),
        {
            name: "TIME TRACKER",
            key: "time-tracker",
            logo: <AssignmentOutlinedIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: "/crm/Staff-attendance",
            active: ['staff-attendance',]
        },

       
       
        {
            name: "END OF DAY",
            key: "end-of-day",
            logo: <SummarizeIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: `/crm/eod-report`,
            active: ["eod-report"] 
        },
        // 
        {
            name: "ACTIVITY LOGS",
            key: "activity-log",
            logo: <NaturePeopleIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: `/crm/activity-log`,
            active: ["activity-log"]
        },
        {
            name: "REPORTS",
            key: "reports",
            logo: <SummarizeOutlinedIcon style={{color: '#9CA3AF', fontSize: "28px"}} />,
            url: `/crm/reports`,
            active: ["reports"]
        },
        {
            name: "INVENTORY",
            key: "inventory",
            logo: <CategoryIcon sx={{fontSize:"28px", color:'#9CA3AF'}}/>,
            url: "/crm/inventory",
            active:['inventory',]
        },


        //



    ];
    if (user?.role_id === 4) {
        const menuKeys = user.menus.map(menu => menu.key); // Extract menu keys from user.menus
        return allItems.filter(item => menuKeys.includes(item.key)); // Filter items based on presence of key in menuKeys
    } else {

        return allItems; 
    }   
    // Filter out any null values resulting from the conditional inclusion
}
const callLogsRoutes = [
    {   
        name: "APPOINTMENT",
        key: "appointment-call-logs",
        logo: <CircleIcon sx={{fontSize:"14px"}}/>,
        url: "/crm/appointment-call-logs",
        active:['appointment-call-logs',]
    },
    {
        name: "TREATMENT",
        key: "treatment-call-logs",
        logo: <CircleIcon sx={{fontSize:"14px"}}/>, 
        url: "/crm/treatment-call-logs",
        active:['treatment-call-logs',]   
    },
]
// const inventoryRoutes = [
//     {
//         name: "PRODUCT",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/inventory/product",
//         active:['product',]
//     },
//     {
//         name: "ADD PRODUCT",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,  
//         url: "/crm/inventory/product/basic-info",
//         active:['basic-info','pricing','inventory','brand','category',"vendor","product-image"]
//     },
//     {  
//         name: "PURCHASED",   
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/inventory/purchase",
//         active:['purchase',]
//     },
//     {
//         name: "INV CONSUME",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/inventory/inv-consume",
//         active:['inv-consume',]
//     },
// ]
// const reportsRoutes = [
//     {
//         name: "GENERAL REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/general-report",
//         active:['general-report',]
//     },
//     {
//         name: "SALE REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/sale-report" ,
//         active:['sale-report',]
//     },
//     {
//         name: "GIFT CARD REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/gift-card-report" ,
//         active:['gift-card-report',]
//     },
//     {
//         name: "MEMBER REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/member-report",
//         active:['member-report',]
//     },
//     // {
//     //     name: "EOD REPORTS",
//     //     logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//     //     url: "/crm/eod-report",
//     //     active:['eod-report',]
//     // },
//     {
//         name: "Staff REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/staff-sale-report" ,
//         active:['staff-sale-report',]
//     },
//     {
//         name: "CATEGORY REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/category-sale-report",
//         active:['category-sale-report',]
//     },
//    {
//         name: "WALLET REPORTS",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,
//         url: "/crm/wallet-report",
//         active:['wallet-report',]
//     },     
//     {     
//         name: "ATTENDENCE",
//         logo: <CircleIcon sx={{fontSize:"14px"}}/>,   
//         url: "/crm/attendance-report",
//         active:['attendance',]
//     },  

// ]
 
export const CustomDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: 250,
        flexShrink: 0,
        zIndex:'11',
        whiteSpace: 'nowrap',   
        boxSizing: 'border-box',
        ".css-12i7wg6-MuiPaper-root-MuiDrawer-paper":{
            zIndex:'11',
        },
        ...(open && {
            ...openedMixin(theme,250),
            '& .MuiDrawer-paper': openedMixin(theme,250),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const CRMSidebar = ({ sidebarOpen,mobileOpen,setMobileOpen }) => {
    const [open, setOpen] = useState(0);    
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();   
    const isMdScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const {pathname} = location;
    const authStore = useSelector((state) => state?.authStore);
    const { user } = authStore;
    const params = useParams()
    // GoTo unread badge on the CONVERSATIONS tab. Count + provider channel id
    // come from the server (correct for staff logins too).
    const gotoUnread = useSelector((state) => state?.gotoSmsStore?.unreadTotal || 0);
    const gotoProviderId = useSelector((state) => state?.gotoSmsStore?.providerId);

    // Seed the badge on mount (also resolves providerId for the live channel).
    useEffect(() => {
        dispatch(getGotoUnreadCount());
    }, [dispatch]);

    // Live: any inbound on the clinic's goto-inbox channel re-pulls the
    // authoritative count, so the badge updates from any page — not just the
    // Conversations board.
    useEffect(() => {
        if (!gotoProviderId) return undefined;
        const unsubscribe = gotoSmsApi.subscribeInbox(gotoProviderId, () => {
            dispatch(getGotoUnreadCount());
        });
        return () => {
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, [dispatch, gotoProviderId]);

    const sideData = getSideData(user).map((item) =>
        item.key === "conversations"
            ? { ...item, count: gotoUnread > 0 ? gotoUnread : null }
            : item
    );
    // Collapsed = permanent rail on desktop with the label area hidden.
    // (On <lg the temporary drawer always shows the full expanded content.)
    const collapsed = !sidebarOpen && !isMdScreen;

    const handleNavigate = (url, menuKey) => {
        if (!hasMenuAccess(user, menuKey)) {
            // Redirect to first allowed menu or dashboard
            const firstAllowedMenu = sideData[0]?.url || '/crm/dashboard';
            navigate(firstAllowedMenu);
            setMobileOpen(false);
            return;
        }
        setMobileOpen(false);
        navigate(url);
    };
    const handleClick = (val) => {
        setOpen(val === open ? 0 : val);
    }; 
    const handleLogout = async () => {
       
            // Navigate to login page
            navigate("/crm/user-manual");
    
            // Optionally, force a page reload
          
    };
    const shouldDisplayMenu = (menuKey) => {
        // Check if user role is 4 and then check if the menuKey exists in user.menus
        return user?.role_id === 4 ? user.menus.some(menu => menu.key === menuKey) : true;
    };
    const checkActive = (activeArray) => {

        let res = pathname.split('/')
        let lastValue
        if (pathname.includes('edit-')) {  
            lastValue = res[res?.length - 2]; 

        } else {
            lastValue = res[res?.length - 1];  
        }
        return !!activeArray.includes(lastValue)
        // return pathname.includes(activeArray)
    }
     
    const drawer = () => (
        <Box
            sx={{
                background: "linear-gradient(160deg, #FDF0F6 0%, #FAF6F2 50%, #FFF8F4 100%)",
                borderRight: " 1px solid #F0CDDB",
                height: "100vh",
                padding: sidebarOpen || isMdScreen ? "16px 5px 16px 16px" : "6px",
                '@media (max-width:350px)':{ padding:"16px 16px" },
                '@media (max-width:319px)':{ padding:"6px 15px" },
                overflowY: "auto",
                ...scrollCSS,
                '&::-webkit-scrollbar': { width: collapsed ? '4px' : '8px' },
                '&::-webkit-scrollbar-track': { background: 'transparent', borderRadius: '8px' },
                '&::-webkit-scrollbar-thumb': { background: collapsed ? 'rgba(167,44,104,0.25)' : '#A72C68', borderRadius: '8px', border: collapsed ? 'none' : '2px solid #FAEFF5' },
                '&::-webkit-scrollbar-thumb:hover': { background: collapsed ? 'rgba(167,44,104,0.45)' : '#9CA3AF' },
                scrollbarColor: collapsed ? 'rgba(167,44,104,0.25) transparent' : '#A72C68 #FAEFF5',
                scrollbarWidth: 'thin',
            }}
        >
            <Box
                sx={{
                    mt:"3px",
                    mb: "3px",    
                }}
            >    
                {sidebarOpen || isMdScreen ? (
                    <Link to={"/"}>
                        <img src={zoey} alt={"logo"} height={"fit-content"} width={"100%"}/>
                    </Link>
                ) : <></>}
            </Box>
            <Box>
                <List
                    sx={{  
                        width: "100%",  
                        ".MuiListItemIcon-root ": {
                            minWidth: "37px",
                        },
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                >
                  {sideData?.map((item, index) => (
  <ListItemButton
    key={index}
    onClick={() => handleNavigate(item?.url, item?.key)}
    sx={{
      ...listItemHoverStyle,
      ...(collapsed && { padding: '10px 0', justifyContent: 'center', "& .MuiListItemIcon-root": { minWidth: 'unset' } }),
      backgroundColor: checkActive(item?.url) ? "#A72C68" : "transparent",
      color: checkActive(item?.url) ? "#fff" : "#1a1a2e",
      border: item.key === "Zoey-Ai" ? '1px solid #F0CDDB' : "",
      justifyContent: collapsed ? "center" : "space-between",
      "&:hover": {
        backgroundColor: checkActive(item?.url) ? "#921F58" : "rgba(167,44,104,0.08)",
      },
      "&::before": checkActive(item?.url) ? {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '6px',
        bottom: '6px',
        width: '4px',
        borderRadius: '0 4px 4px 0',
        background: '#A72C68',
      } : {},
      "& .MuiTypography-root": { color: checkActive(item?.url) ? '#fff !important' : '#1a1a2e !important' },
      "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: checkActive(item?.url) ? '#fff !important' : '#1a1a2e !important' },
      "& .MuiListItemIcon-root svg path, & .MuiListItemIcon-root svg circle, & .MuiListItemIcon-root svg line, & .MuiListItemIcon-root svg rect, & .MuiListItemIcon-root svg polyline, & .MuiListItemIcon-root svg polygon": { stroke: checkActive(item?.url) ? '#fff !important' : '#1a1a2e !important' },
    }}
  >
    {/* "New" tag for Zoey-Ai */}
    {item.key === "Zoey-Ai" && (
      <Typography
        variant="body2"
        sx={{
          position: "absolute",
          top: "5px",
          right: "10px",
          background: "#ff1361",
          backgroundImage:
            "linear-gradient(-225deg, #ff1361 0%, #44107a 29%, #ff1361 67%, #fff800 100%)",
          backgroundSize: "200% auto",
          color: "transparent",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animation: "textclip 2s linear infinite",
          fontSize: "14px",
          fontWeight: "bold",
          "@keyframes textclip": {
            to: { backgroundPosition: "200% center" },
          },
        }}
      >
        New
      </Typography>
    )}

    <Box sx={{ display: "flex", alignItems: "center" }}>
      <ListItemIcon>{item?.logo}</ListItemIcon>
      {(sidebarOpen || isMdScreen) && (
        <ListItemText
          primary={item?.name}
          primaryTypographyProps={{ sx: { fontWeight: 700, fontSize: '14px', letterSpacing: '0.04em', fontFamily: 'helvetica-lt-std-bold,sans-serif' } }}
        />
      )}
    </Box>

    {/* ✅ Show count if present */}
    {item?.count > 0 && (
      <Box
        sx={{
          background: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
          color: "#fff",
          fontSize: "11px",
          px: "7px",
          py: "2px",
          borderRadius: "20px",
          minWidth: "22px",
          textAlign: "center",
          fontWeight: 700,
          boxShadow: "0 2px 4px rgba(239, 68, 68, 0.35)",
          letterSpacing: "0.01em",
        }}
      >
        {item.count}
      </Box>
    )}
  </ListItemButton>
))}


                    {shouldDisplayMenu('call-logs') && (
                        <>
                        <ListItemButton
                            onClick={() => handleClick(2)}
                            sx={{
                                ...listItemHoverStyle,
                                ...(collapsed && { padding: '10px 0', justifyContent: 'center', "& .MuiListItemIcon-root": { minWidth: 'unset' } }),
                                backgroundColor: open === 2 ? "#A72C68" : "transparent",
                                color: open === 2 ? "#fff" : "#1a1a2e",
                                "&:hover": {
                                    backgroundColor: open === 2 ? "#921F58" : "rgba(167,44,104,0.08)",
                                },
                                "&::before": open === 2 ? {
                                    content: '""',
                                    position: 'absolute',
                                    left: 0,
                                    top: '6px',
                                    bottom: '6px',
                                    width: '4px',
                                    borderRadius: '0 4px 4px 0',
                                    background: '#A72C68',
                                } : {},
                                "& .MuiTypography-root": { color: open === 2 ? '#fff !important' : '#1a1a2e !important' },
                                "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: open === 2 ? '#fff !important' : '#1a1a2e !important' },
                                "& .MuiListItemIcon-root svg path, & .MuiListItemIcon-root svg circle, & .MuiListItemIcon-root svg line, & .MuiListItemIcon-root svg rect, & .MuiListItemIcon-root svg polyline, & .MuiListItemIcon-root svg polygon": { stroke: open === 2 ? '#fff !important' : '#1a1a2e !important' },
                                "& > svg": { color: open === 2 ? '#fff !important' : '#1a1a2e !important' },
                            }}
                        >
                            <ListItemIcon><Box sx={{color: open === 2 ? '#fff' : '#1a1a2e', display:'flex', '& svg':{width:28, height:28, color:'inherit', fill:'currentColor', stroke:'currentColor'}, '& svg path, & svg circle, & svg line, & svg rect, & svg polyline':{stroke:'currentColor'}}}><Call/></Box></ListItemIcon>
                            {!collapsed && <ListItemText primary="CALL LOGS" primaryTypographyProps={{ sx: { fontWeight: 700, fontSize: '14px', letterSpacing: '0.04em', fontFamily: 'helvetica-lt-std-bold,sans-serif' } }}/>}
                            {!collapsed && (open === 2 ? <MdExpandLess fontSize={"24px"} color={"#fff"}/> : <MdExpandMore fontSize={"24px"} color={"#1a1a2e"}/>)}
                        </ListItemButton>
                        <Collapse in={open === 2} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {callLogsRoutes.map((item, index) => (
                                    <ListItemButton
                                        key={index}
                                        onClick={() =>
                                            handleNavigate(item?.url,item?.key)
                                        }
                                        sx={{
                                            borderRadius: "8px",
                                            mb: "8px",
                                            padding: '8px 18px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            transition: 'background-color 0.3s, color 0.3s',
                                            backgroundColor: checkActive(item?.active) ? "#A72C68" : "transparent",
                                            "&::before": checkActive(item?.active) ? {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '6px',
                                                bottom: '6px',
                                                width: '4px',
                                                borderRadius: '0 4px 4px 0',
                                                background: '#A72C68',
                                            } : {},
                                            "& .MuiTypography-root": { color: checkActive(item?.active) ? '#fff !important' : '#1a1a2e !important' },
                                            "& .MuiListItemIcon-root, & .MuiListItemIcon-root *": { color: checkActive(item?.active) ? '#fff !important' : '#1a1a2e !important' },
                                            "& .MuiListItemIcon-root svg path, & .MuiListItemIcon-root svg circle, & .MuiListItemIcon-root svg line, & .MuiListItemIcon-root svg rect, & .MuiListItemIcon-root svg polyline, & .MuiListItemIcon-root svg polygon": { stroke: checkActive(item?.active) ? '#fff !important' : '#1a1a2e !important' },
                                            "&:hover": {
                                                backgroundColor: checkActive(item?.active) ? "#921F58" : "rgba(167,44,104,0.08)",
                                                "& .MuiTypography-root": { color: checkActive(item?.active) ? '#fff' : '#A72C68' },
                                                "& .MuiListItemIcon-root svg, & .MuiListItemIcon-root .MuiSvgIcon-root": { color: checkActive(item?.active) ? '#fff' : '#A72C68' },
                                            },
                                            "&:hover::before": {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '6px',
                                                bottom: '6px',
                                                width: '4px',
                                                borderRadius: '0 4px 4px 0',
                                                background: '#A72C68',
                                            },
                                        }}
                                    >
                                        <ListItemIcon sx={{minWidth:"28px!important"}}>{item?.logo}</ListItemIcon>
                                        <ListItemText primary={item?.name} primaryTypographyProps={{ sx: { fontWeight: 600, fontSize: '13px', letterSpacing: '0.03em', fontFamily: 'helvetica-lt-std-roman,sans-serif' } }}/>
                                    </ListItemButton>
                                ))}  
                            </List>
                        </Collapse>
                        </>    
                    )}  
                    {/* {shouldDisplayMenu('inventory') && (
                        <>
                        <ListItemButton
                            onClick={() => handleClick(3)}
                        > 
                            <ListItemIcon>
                                <InventoryIcon style={{color:'#9CA3AF'}}/>
                            </ListItemIcon>
                            <ListItemText primary="INVENTORY" primaryTypographyProps={{ sx: { fontWeight: 700, fontSize: '14px', letterSpacing: '0.04em', fontFamily: 'helvetica-lt-std-bold,sans-serif' } }}/>
                            {open === 3 ? <MdExpandLess fontSize={"24px"}/> : <MdExpandMore fontSize={"24px"}/>}
                        </ListItemButton>
                        <Collapse in={open === 3} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {inventoryRoutes.map((item, index) => (
                                    <ListItemButton
                                        key={index}
                                        onClick={() =>
                                            handleNavigate(item?.url)
                                        }
                                        sx={{
                                            borderRadius: "7px",
                                            mb: "7px",
                                            backgroundColor: checkActive(item?.active) ? "#FAEFF5" : "#fff",
                                            "&:hover": {
                                                backgroundColor: "#FAEFF5",
                                            },
                                        }}
                                    >
                                        <ListItemIcon sx={ {minWidth:"28px!important"}}>{item?.logo}</ListItemIcon>
                                        <ListItemText primary={item?.name} primaryTypographyProps={{ sx: { color: '#E5A8C2', fontWeight: 600, fontSize: '13px', letterSpacing: '0.03em', fontFamily: 'helvetica-lt-std-roman,sans-serif' } }}/>
                                    </ListItemButton>
                                ))}                 
                            </List>
                        </Collapse>
                        </>
                    )} */}
                    {/* <ListItemButton
                        onClick={() => handleLogout()}
                        sx={{
                            borderRadius: "7px",
                            "&:hover": {
                                backgroundColor: '#fff',
                                color: "#A72C68",
                            },
                        }}
                    >
                        <ListItemIcon>
                        <OndemandVideoIcon style={{ color:'#9CA3AF',fontSize: "1.5rem"}}/>
                        </ListItemIcon>
                        {(sidebarOpen || isMdScreen) && <ListItemText primary="User Manual" primaryTypographyProps={{ sx: { fontWeight: 700, fontSize: '14px', letterSpacing: '0.04em', fontFamily: 'helvetica-lt-std-bold,sans-serif' } }}/>}
                    </ListItemButton> */}
                </List>
            </Box>
        </Box>
    )
    return (
        <Box> 
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={() => setMobileOpen(!mobileOpen)}
                sx={{
                    display: {xs: 'block', lg: 'none'},
                    '& .MuiDrawer-paper': {boxSizing: 'border-box', width: {xs: '70%', sm: 250}},
                }}
            >  
                <Box>
                    {drawer()}
                </Box>
            </Drawer>
            <CustomDrawer  
                variant="permanent"
                open={sidebarOpen}
                sx={{
                    display: {xs: 'none', lg: 'block'},
                }}
            >
                {drawer()}
            </CustomDrawer>  
        </Box>
    );  
};

export default CRMSidebar;
